<!-- 组件说明 -->
<template>
  <div class="home">
    <!-- <router-view /> -->
    <!-- <el-drawer @close="close" title="购物车" :visible="showBuyDrawer" size="100%">
      <buy-order></buy-order>
    </el-drawer>-->
    <keep-alive :include="arr">
        <router-view  v-if="isRouterAlive"/>
    </keep-alive>
  </div>
</template>

<script>
import HomeMixin from '@/mixin/mixin-home.js';
import { mapState } from 'vuex';
export default {
  mixins: [HomeMixin],
  name: 'Home',
  components: {},
  data() {
    return {
      drawer: true,
      direction: 'ltl',
      isRouterAlive:true,
      arr:['GoodsCategoryDetail'] // 缓存页面。数组里面可以添加多个需要缓存的页面。
    };
  },
  watch: {
    // 监听router
    $route: function(to, from) {
      if (from.meta.keepAlive) {
        this.arr.includes(from.name) || this.arr.push(from.name)
      } else {
        var name = from.name
        if (this.arr.includes(name)) {
          var index = this.arr.findIndex(function(item) {
            return item === name
          })
          this.arr.splice(index, 1)
        }
      }
      if (to) {
        switch (to.name) {
          // 需要缓存的页面
          case 'GoodsCategoryDetail':
            this.arr.includes(to.name) || this.arr.push(to.name)
            break
          default:
            break
        }
      }
      console.log(`从${from.name}去${to.name},缓存页面有： ${this.arr}`)
    }
  },
  computed: {},
  methods: {},
  created() {
    //生命周期 - 创建完成
  },
  destroyed() {
    //生命周期 - 销毁完成
  },
};
</script>

<style src="../css/index.scss" lang='scss'>
</style>
<style lang='scss'>

.home {
  .el-drawer {
    width: 50vw;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/Home.vue